import styled from '@benzinga/themetron';

export const InputGroup = styled.div`
  &.input-group {
    width: 100%;
    display: flex;
    flex-direction: column;

    > label {
      font-size: ${({ theme }) => theme.fontSize.lg};
      margin-bottom: 5px;
      font-weight: ${({ theme }) => theme.fontWeight.bold};
    }

    input[type='text'] {
      font-size: 15px;
      padding: 0.25rem 0.5rem;
    }

    .ant-tabs-nav-list {
      width: 100%;

      .ant-tabs-tab {
        width: 100%;
        text-align: center;

        > div {
          width: 100%;
        }
      }
    }
  }
`;
